/*eslint-disable eqeqeq*/
import React from 'react';
import PostcodeList from '../../component/componentPostcode/postcodelist';
// import { data } from './postcodedata'
import * as APIController from '../../../../api/APIController.js';
import Notification from '../../../../shared/components/notification/notification';
import { ExcelRenderer } from 'react-excel-renderer';

class PostcodeContainer extends React.Component {

    state = {
        currentPage: 1,
        count: 0,
        list: [],
        list1: [],
        rowsPerPage: 10,
        rowsPerPageOptions: [10, 25, 50, 'All'],
        from: 0,
        to: 10,
        progress: true,
        PostcodeArray: [],
        message: '',
        showNotification: false,
        isError: false,
        showMessage: this.props.history.location.state != null && this.props.history.location.state.showMessage
    }

    componentDidMount() {
        this.wsGetPostcodes(this.state.currentPage, this.state.rowsPerPage, this.state.from, this.state.to);
        this.state.showMessage != '' && this.handleNotification(this.state.showMessage)
        this.props.history.replace('/postcode', null);
    }

    handlebind() {
        this.wsGetPostcodes(this.state.currentPage, this.state.rowsPerPage)
    }

    wsGetPostcodes(CurrentPage, RecordPerPage, from, to, CountryName, StateName, CityName, Postcode) {
        this.setState({ progress: true, });
        APIController.GetPostcodes(CurrentPage, RecordPerPage, CountryName, StateName, CityName, Postcode)
            .then((response) => {
                if (response.object.status == 0 && response.object.data.length != 0) {
                    this.setState({
                        to: isNaN(to) ? 1000000 : to,
                        // rowsPerPage: isNaN(to) ? 1000000 : to,
                        from: from,
                        count: response.object.data[0].MaxRows,
                        list: response.object.data,
                        list1: response.object.data,
                        progress: false,
                    })
                }
                else if (response.object.message && response.object.message.length > 0) {
                    // ToastsStore.warning(response.error.message)
                } else { this.setState({ list: [], progress: false }) }
            })
    }

    wsImportPostcodes(PostcodeArray) {
        this.setState({ progress: true, });
        APIController.ImportPostcodes(PostcodeArray)
            .then((response) => {
                if (response.object.status == 0 && response.object.data.length != 0) {

                }
                else if (response.object.message && response.object.message.length > 0) {
                    // ToastsStore.warning(response.error.message)
                } else { this.setState({ list: [], progress: false }) }
            })
    }

    fileHandler = (event) => {
        let fileObj = event.target.files[0];
        //just pass the fileObj as parameter
        ExcelRenderer(fileObj, (err, resp) => {
            var obj = {};
            var mainobj = []
            for (var i = 1; i < resp.rows.length; i++) {
                for (var j = 0; j < resp.cols.length; j++) {
                    obj[resp.rows[0][j].replace(' ', '')] = resp.rows[i][j];
                }
                mainobj.push(obj);
                obj = {};
            }
            this.setState({ PostcodeArray: mainobj });
            this.wsImportPostcodes(mainobj);
            // this.setState({
            //     list: resp.rows,
            //     cols: resp.cols,
            //     rows: resp.rows
            // });

        });
    }

    render() {
        return (
            <>
                <Notification
                    isError={this.state.isError}
                    message={this.state.message}
                    showNotification={this.state.showNotification}
                    clearNotification={this.handleClearNotification}
                    closeNotification={this.handleClearNotification}
                />
                <section className="content-right-main">
                    <div className="button-field button-field-country">
                        <button onClick={() => {
                            this.props.history.push({
                                pathname: '/postcode/add',
                                state: { postcodeIdEdit: '0', countryIdEdit: '', stateIdEdit: '', cityId: '', postcodeNameEdit: '', postcodeActiveEdit: 1 }
                            })
                        }}>+ Add Postcode</button>
                    </div>
                    <div className="button-field button-field-country">
                        {/* <button className="button-field button-field-country" type='submit' onClick={() => { this.wsImportPostcodes(this.state.PostcodeArray) }}> */}
                        {/* <input type="file" accept=".xlsx,.xls" onChange={this.fileHandler.bind(this)}
                            className="button-field-upload" style={{ "padding": "10px 20px 10px 5px", maxWidth: '1px', }} /> */}
                        <input type="file" accept=".xlsx,.xls" onChange={this.fileHandler.bind(this)} placeholder="+ Import Postcode"
                            style={{ "padding": "10px 110px 10px 5px", marginLeft: '5px', maxWidth: '1px', alignItems: 'center', textAlign: 'center' }}
                            className="button-field-upload" />
                        {/* <label style={{ color: '#fff', zIndex: '0', }} onChange={this.fileHandler.bind(this)}>+ Import Postcode</label> */}
                        {/* </button> */}
                    </div>
                    <PostcodeList {...this.state}
                        history={this.props.history}
                        handlebind={this.handlebind.bind(this)}
                        handleChangeRowsPerPage={this.handleRowsPerPageChange}
                        handleChangePage={this.handlePageChange}
                        applyFilter={this.handleApplyFilter}
                    />
                </section>
            </>
        )
    }

    handleRowsPerPageChange = (value, PostalcodeText, CityText, StateText, CountryText) => {
        let from = 0
        let to = value;
        this.setState({ progress: true, rowsPerPage: value, currentPage: 1, to: to, from: from })
        this.wsGetPostcodes(isNaN(value) ? '' : this.state.currentPage, isNaN(value) ? 1000000 : value, from, to, CountryText, StateText, CityText, PostalcodeText);
    }

    handlePageChange = (values, PostalcodeText, CityText, StateText, CountryText) => {
        let from = values === 1 ? 0 * this.state.rowsPerPage : (values - 1) * this.state.rowsPerPage
        let to = values === 1 ? this.state.rowsPerPage : (from + this.state.rowsPerPage);
        this.setState({ currentPage: Number(values) })
        this.wsGetPostcodes(Number(values), this.state.rowsPerPage, from, to, CountryText, StateText, CityText, PostalcodeText);
    }

    handleApplyFilter = (PostalcodeText, CityText, StateText, CountryText) => {
        this.wsGetPostcodes(this.state.currentPage, this.state.rowsPerPage, this.state.from, this.state.to, CountryText, StateText, CityText, PostalcodeText)
    }
    handleNotification = (message, isError) => {
        this.setState({
            message: message,
            showNotification: true,
            isError: isError
        })

        setTimeout(() => {
            this.handleClearNotification();
        }, 4000)
    }

    handleClearNotification = () => {
        this.setState({
            message: '',
            showNotification: false,
            isError: false
        })
    }
}

export default PostcodeContainer;